import React, { useState, useRef, useEffect, useId } from 'react'
import './ui.css'

function Tooltip({ text, children, position = 'top' }) {
  const [visible, setVisible] = useState(false)
  const [adjustedPosition, setAdjustedPosition] = useState(position)
  const tooltipRef = useRef(null)
  const wrapperRef = useRef(null)
  const tooltipId = useId()

  useEffect(() => {
    if (!visible) {
      setAdjustedPosition(position)
      return
    }
    if (!tooltipRef.current || !wrapperRef.current) return
    const wrapper = wrapperRef.current.getBoundingClientRect()

    if (position === 'top' && wrapper.top < 80) {
      setAdjustedPosition('bottom')
    } else if (position === 'bottom' && wrapper.bottom + 80 > window.innerHeight) {
      setAdjustedPosition('top')
    } else {
      setAdjustedPosition(position)
    }
  }, [visible, position])

  const show = () => setVisible(true)
  const hide = () => setVisible(false)

  if (!text) return children || null

  return (
    <span
      className="ui-tooltip-wrapper"
      ref={wrapperRef}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      tabIndex={0}
      aria-describedby={visible ? tooltipId : undefined}
    >
      {children || (
        <svg className="ui-tooltip-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
          <path d="M10 9.5C10 8.12 11.12 7 12.5 7C13.88 7 15 8.12 15 9.5C15 10.88 13.88 12 12.5 12V13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="12.5" cy="16.5" r="1" fill="currentColor" />
        </svg>
      )}
      {visible && (
        <span id={tooltipId} className={`ui-tooltip ui-tooltip-${adjustedPosition}`} ref={tooltipRef} role="tooltip">
          {text}
        </span>
      )}
    </span>
  )
}

export default Tooltip
